import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import cta from "../../assets/CTABackground.png"


const Member = ({ openModal }) => {

  const { t } = useTranslation();

  return (
    <div className='p-5 rounded-4 text-white my-5'  style={{ 
    backgroundImage: `url(${cta})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }}>
      <Row className='justify-content-center align-items-center'>
        <Col lg="8" className='my-3'>
          <div className='fs-2 fw-bold'>{t('member_title')}</div>
          <p className='fs-6 mt-2'>{t('member_text')}</p>
        </Col>
        <Col lg="4" className='my-3'>
          <div className='d-flex justify-content-end'>
            <button className='w-50 bg-white bg-opacity-50 py-3 px-5 rounded-3' onClick={() => openModal("up")}>{t('join_us')}</button>
          </div>
        </Col>
      </Row>
   
    </div>
  )
}

export default Member
